<div [formGroup]="formGroup">
  <pas-accordion [isClosed]="false" title="{{ 'GENERAL_DATA' | translate }}">
    <ng-template pasAccordionBody>
      <div class="container">
        <div class="row gy-3">
          <!--1 Supplier -->
          <div class="col-4">
            <pas-input
              [maxLength]="6"
              [formControl]="$any(formGroup.get('formCtrlSupplier'))"
              (ngModelChange)="onSupplierChanged()"
              subLabel="{{ 'partsAgreement.supplierNumber' | translate }}"></pas-input>
          </div>
          <div class="col-4" style="padding-top: 5px">
            <label>
              <b>{{ 'partsAgreement.supplierName' | translate }}</b>
            </label>
            <label>&nbsp;{{ formGroup.get('formCtrlName').value }}</label>
          </div>
          <div class="col-4" style="padding-top: 5px">
            <label>
              <b>{{ 'partsAgreement.add.supplierCity' | translate }}</b>
            </label>
            <label>&nbsp;{{ formGroup.get('formCtrlCity').value }}</label>
          </div>

          <!--2 partNumber -->
          <div class="col-4">
            <pas-input
              [maxLength]="compPartNumberMaxLength"
              [formControl]="$any(formGroup.get('formCtrlPartNumber'))"
              subLabel="{{ 'partsAgreement.sparePartNumber' | translate }}"></pas-input>
            @if (formGroup.controls['formCtrlPartNumber'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlPartNumber'].errors.minlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.partNumberValidation' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlPartNumber'].errors.maxlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.partNumberValidation' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlPartNumber'].errors.pattern) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.validatorInvalidCharacters' | translate }}
                  </div>
                }
              </span>
            }
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>

          <!-- 3 technicalFactor -->
          <div class="col-4">
            <pas-input-number
              [decimalSeparator]="decimalSeparator"
              [decimalCount]="2"
              [maxLength]="5"
              [formControl]="$any(formGroup.get('formCtrlTechnicalFactor'))"
              subLabel="{{ 'partsAgreement.technicalFactor' | translate }}"
              formControlName="formCtrlTechnicalFactor"></pas-input-number>
            @if (formGroup.controls['formCtrlTechnicalFactor'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlTechnicalFactor'].errors.numberNotAllowed) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.technicalFactorValidation' | translate }}
                  </div>
                }
              </span>
            }
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>

          <!--4 orderType -->
          <div class="col-4">
            <pas-input
              [maxLength]="compOrderTypeMaxLength"
              [formControl]="$any(formGroup.get('formCtrlOrderType'))"
              subLabel="{{ 'partsAgreement.orderType' | translate }}"></pas-input>
            @if (formGroup.controls['formCtrlOrderType'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlOrderType'].errors.minlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.orderTypeValidation' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlOrderType'].errors.maxlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.orderTypeValidation' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlOrderType'].errors.pattern) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.validatorInvalidCharacters' | translate }}
                  </div>
                }
              </span>
            }
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>

          <!-- 5 modelYear -->
          <div class="col-4">
            <pas-input-number
              [maxLength]="compModelYearMaxLength"
              [formControl]="$any(formGroup.get('formCtrlModelYearFrom'))"
              [decimalCount]="0"
              subLabel="{{ 'partsAgreement.modelYearFrom' | translate }}"></pas-input-number>

            @if (formGroup.controls['formCtrlModelYearFrom'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlModelYearFrom'].errors.minlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.modelYearFormat' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlModelYearFrom'].errors.maxlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.modelYearFormat' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlModelYearFrom'].errors.number_mismatch) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.modelYearNotAllowed' | translate }}
                  </div>
                }
              </span>
            }
          </div>

          <div class="col-4">
            <pas-input-number
              [maxLength]="compModelYearMaxLength"
              [formControl]="$any(formGroup.get('formCtrlModelYearTo'))"
              [decimalCount]="0"
              subLabel="{{ 'partsAgreement.modelYearTo' | translate }}"></pas-input-number>
            @if (formGroup.controls['formCtrlModelYearTo'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlModelYearTo'].errors.minlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.modelYearFormat' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlModelYearTo'].errors.maxlength) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.modelYearFormat' | translate }}
                  </div>
                }
              </span>
            }
          </div>
          <div class="col-4"></div>

          <!-- 6 productionDate -->
          <div class="col-4">
            <pas-datetime-picker
              [formControl]="$any(formGroup.get('formCtrlProductionDateFrom'))"
              [maxDate]="longTimeAhead"
              class="col-12"
              pickerType="date"
              subLabel="{{ 'partsAgreement.productionDateFrom' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
            @if (formGroup.controls['formCtrlProductionDateFrom'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlProductionDateFrom'].errors.date_mismatch) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.modelYearNotAllowed' | translate }}
                  </div>
                }
              </span>
            }
          </div>

          <div class="col-4">
            <pas-datetime-picker
              [formControl]="$any(formGroup.get('formCtrlProductionDateTo'))"
              [maxDate]="longTimeAhead"
              class="col-12"
              pickerType="date"
              subLabel="{{ 'partsAgreement.productionDateTo' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
          </div>

          <div class="col-4"></div>

          <!-- 7 validityDate -->
          <div class="col-4">
            <pas-datetime-picker
              [formControl]="$any(formGroup.get('formCtrlValidityDateFrom'))"
              [minDate]="tomorrow"
              [maxDate]="longTimeAhead"
              class="col-12"
              pickerType="date"
              subLabel="{{ 'partsAgreement.validityDateFrom' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
            @if (formGroup.controls['formCtrlValidityDateFrom'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlValidityDateFrom'].errors.date_mismatch) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.modelYearNotAllowed' | translate }}
                  </div>
                }
                @if (formGroup.controls['formCtrlValidityDateFrom'].errors.currentDateValidator) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.validationCurrentDate' | translate }}
                  </div>
                }
              </span>
            }
          </div>

          <div class="col-4">
            <pas-datetime-picker
              [formControl]="$any(formGroup.get('formCtrlValidityDateTo'))"
              [maxDate]="longTimeAhead"
              class="col-12"
              pickerType="date"
              subLabel="{{ 'partsAgreement.validityDateTo' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
            @if (formGroup.controls['formCtrlValidityDateTo'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlValidityDateTo'].errors.currentDateValidator) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.add.validationCurrentDate' | translate }}
                  </div>
                }
              </span>
            }
          </div>
          <div class="col-4"></div>

          <!-- 8 comment -->
          <div class="col-8">
            <pas-textarea
              [maxLength]="compCommentCharactersMaxLength"
              [formControl]="$any(formGroup.get('formCtrlComment'))"
              (ngModelChange)="onCommentChanged()"
              class="col-12"
              id="comment"
              subLabel="{{ 'partsAgreement.add.comment' | translate }}"></pas-textarea>
            @if (formGroup.controls['formCtrlComment'].invalid) {
              <span class="errorSpan">
                @if (formGroup.controls['formCtrlComment'].errors.invalidCommentCharacters) {
                  <div class="errorDiv">
                    {{ 'partsAgreement.commentInvalidCharacters' | translate }}
                  </div>
                }
              </span>
            }
            <label class="infoDiv">{{ 'partsAgreement.add.commentCharacterLeft' | translate }}</label>
            <label class="infoDiv">{{ compCommentCharactersLeft }}</label>
          </div>
        </div>
      </div>
    </ng-template>
  </pas-accordion>
</div>

<!-- Sidebar -->
<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <div class="sidebar-element sidebar-row">
      <ul class="navbar-nav">
        <ng-container>
          <!-- Save -->
          @if (canAddAndEditFactorCriteria) {
            <li [ngClass]="isSaveEnabled() ? 'nav-item' : 'nav-item disabled'">
              <a (click)="onBtnSave()" class="nav-link link-sidebar">
                <i class="material-icons">save</i>
                <span class="hidden-md-down" ui-test-id="saveFactorCriteriaBtn">
                  {{ 'partsAgreement.add.btnSave' | translate }}
                </span>
              </a>
            </li>
          }
          <!-- Cancel -->
          <li class="nav-item">
            <a (click)="onBtnCancel()" class="nav-link link-sidebar">
              <i class="material-icons">cancel</i>
              <span class="hidden-md-down" ui-test-id="cancelFactorCriteriaBtn">
                {{ 'partsAgreement.add.btnCancel' | translate }}
              </span>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</pas-sidebar-holder>
